// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__zH-vH","name":"ConsentHeader_name__35N9C","birthday":"ConsentHeader_birthday__27Wxj","skeleton":"ConsentHeader_skeleton__3SG-o"};